
export default class Card {
	constructor(user = {}) {
		this.user = user;
	}
}
